import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiService} from '../../api.service';
import { HttpClient } from "@angular/common/http";
import {NGXLogger} from "ngx-logger";
import {ActivatedRoute, Router} from "@angular/router";
import {LocaleService} from "../../../locale.service";
import {Backend, SingleResponse} from "@generated-backend-types";
import Page = Backend.App.Http.Resources.Ticketshop.Content.Page;


@Injectable({
  providedIn: 'root'
})
export class PageService extends ApiService {
  private endpoint = '/content/pages';

  public get(slug: string): Observable<SingleResponse<Page>> {
    return this.http.get<SingleResponse<Page>>(this.endpoint + '/by-slug', {params: {slug: slug}});
  }

  constructor(
    public override http: HttpClient,
    public override log: NGXLogger,
    public localeService: LocaleService,
    public router: Router,
    public activatedRoute: ActivatedRoute
  ) {
    super(http, log);
  }
}
